<template>
	<div class='dynamics-wrap'>

		<div class="flex border-5 tab-list">
			<div class="border-5" v-for="item in tabList" :key="item.id" :class="{active: item.name===tabId}" @click="tabHandle(item)">{{item.name}}</div>
		</div>
		<div class="list-wrap wrap-border">
			<ul class="" v-if="list.length>0">
				<li class="" v-for="item in list" :key="item.id">
					<router-link :to="`/common/article/9/${item.id}`" tag="a">
						<div class="flex" :title="item.title">
							<p class="ellipsis-1">{{item.title}}</p>
							<p class="ellipsis-1 source-wrap flex flex-row-end"><span class="source">来源</span><span>{{item.source}}</span></p>
							<p>{{item.publishtime}}</p>
						</div>
						<div class="list-brief">{{item.description|sliceBrief}}</div>
					</router-link>
				</li>
			</ul>
			<empty v-else />
		</div>
		<el-pagination v-if="list.length>0" background layout="total, prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />

	</div>
</template>

<script>
import { getNotices } from '@/api'
import { page } from '@/mixins/page.js';
export default {
	components: {
	},
	mixins: [page],
	data() {
		return {
			tabList: [
				{
					id: 1,
					name: '通知公告',
				},
			],
			tabId: '通知公告',

			
		};
	},

	mounted() {
		this.$emit('layoutInit', {
			menus: this.tabId
		})
	},
	methods: {
		// tabHandle(row) {
		// 	const { id, name } = row;
		// 	if (this.tabId !== name) {
		// 		this.$emit('layoutInit', {
		// 			menus: this.tabId
		// 		})
		// 		this.$set(this, 'tabId', name);
		// 		this.getLicenseList(1)
		// 	}
		// },

				// 通知公告
		getNotices() {
			getNotices({ current: 1 }).then(res => {
				const { records, total } = res;
				if (total > 0) {
					this.$set(this, 'tzgg', records);
				}

			})
		},
        async getNewsList(page = 1) {
			// await this.getTabList('creditDynamic');
			getNotices({ current: page,  }).then(res => {
				// const { records, recommend } = res;
				// this.$emit('layoutInit', {
				// 	recommend,
				// });
				this.pageHandle(res);
			})
		},
	},
	computed: {},
	watch: {},
};
</script>
<style  lang="scss">
	@import '../assets/css/left.scss';
	.list-wrap {
		padding: 0 17px !important;
		.both-link {
			padding: 0 !important;
			& > a.flex {
				& > p {
					line-height: 55px;
					&:first-of-type {
						flex-grow: 2;
					}
				}
			}
		}
	}
</style>